/**
 *
 * @returns {*[]}
 */

export function generateArrayOfYears() {
  let max = new Date().getFullYear()
  let min = max + 50
  let years = []

  // eslint-disable-next-line no-plusplus
  for (let i = max; i <= min; i++) {
    years.push(i)
  }
  return years
}
